import Vue from 'vue'
import router from '@/router'
import setupAxiosInterceptor from '@/api'
setupAxiosInterceptor()

Vue.prototype.$goTo = target => {
  // console.log('path', target, router.currentRoute.path)
  if (target !== router.currentRoute.path) {
    router.push(target)
  }
}

Vue.prototype.$delay = delay => {
  return new Promise((resolve, reject) => setTimeout(resolve, delay))
}
